<template>
  <div>
    <v-card-title>
      {{ title }}
    </v-card-title>
    <v-card-text class="">
      <v-row>
        <v-col cols="4">
          <h2 class="text-h5">What are you saying</h2>
          <v-textarea
            label="Title"
            color="green"
            v-model="doc.saying"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
          />

          <v-textarea
            label="Description"
            color="green"
            v-model="doc.description"
            :rows="1"
            :autoGrow="true"
            :hide-details="false"
          />
        </v-col>
        <v-col cols="4">
          <h2 class="text-h5">What are you doing</h2>
          <unit-sub-items v-model="doc.doing" name="sub">
            <p class="ma-0">Type below and press <strong>Add</strong></p>
          </unit-sub-items>
        </v-col>
        <v-col cols="4">
          <h2 class="text-h5">How do we get there</h2>
          <unit-sub-items v-model="doc.actions" name="sub">
            <p class="ma-0">Type below and press <strong>Add</strong></p>
          </unit-sub-items>
        </v-col>

        <v-col cols="4">
          <h2 class="text-h5">Status</h2>
          <v-select
            :items="colors"
            label="Status"
            :value="defaultSelected"
            v-model.trim="doc.color"
            item-text="title"
            item-value="color"
          ></v-select>
        </v-col>
        <v-col cols="8">
          <slot></slot>
        </v-col>
      </v-row>
    </v-card-text>
  </div>
</template>

<script>
// @ is an alias to /src

import { UnitSubItems } from "@/components/units";
import { mapState } from "vuex";

export default {
  name: "SayForm",
  data() {
    return {
      item: this.value,
      audiencesRules: [(v) => !!v || "Audience is required"],
      attributesRules: [(v) => !!v || "Attribute is required"],
      colors: [
        { title: "Green", color: "green" },
        { title: "Amber", color: "amber" },
        { title: "Red", color: "red" },
      ],
    };
  },

  props: {
    value: Object,
    name: String,
    title: String,
    doc: Object,
  },
  computed: {
    ...mapState(["colors"]),
  },
  components: {
    UnitSubItems,
  },
  watch: {
    value: {
      handler: function(val) {
        this.item = val;
      },
      deep: true,
    },
  },
};
</script>
